import { Container } from 'react-bootstrap'
import React from 'react'
import { ForgotPass } from './ForgotPass'
import { NewForgotPass } from './NewForgotPass'

const country = process.env.REACT_APP_COUNTRY;

export const PageForgotPass = () => {
  return (
    <div>
      <img src={"https://raw.githubusercontent.com/RamiroSB/imagenes/main/rma-banner.png"} alt="Imagen marcas" className='imagenesBody' loading='lazy'></img>
      <Container>
        {country === 'ARG' || country === 'DO' || country === 'USA' ? <NewForgotPass /> : <ForgotPass />}
      </Container>
    </div>
  )
}